import CascadingAction from "@/action/CascadingAction"
import { applyService, sessionService } from "@/service"
import { providerState } from "@/state"
import { isAnyApprovalCode } from "@/model/apply/ApplyResponseCode"

class BaseFullApplyAction extends CascadingAction {

    async invoke() {
        sessionService.setMinTimeoutMillis(300000)

        const response = await this._submit()

        if (response.provider) {
            providerState.setApplyResponse(this.providerKey, response.provider)
            providerState.setStipulations(this.providerKey, response.provider.stipulations)
        }

        if (isAnyApprovalCode(response?.provider?.responseCode)) {
            const paymentPlansResponse = await applyService.getPaymentPlans(this.providerKey, {
                amountCents: response.provider.approvedAmountCents,
            })

            providerState.setPaymentPlans(this.providerKey, paymentPlansResponse.paymentPlans)
        }

        return response
    }

    _submit() {
        throw new Error("Not Implemented")
    }
}

export default BaseFullApplyAction
